export default __webpack_public_path__ + "static/apple_logo-895f0045ca991e279f0d78906dc0066a.png";